import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import TitleBar from '../../Layout/titleBar'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField';
import Turnos from './turnos'
const styles = theme => ({
  root: {
    flexGrow: 1,
    maxWidth: '20%',
    backgroundColor: 'transparent',
  },
  tabsRoot: {
    borderBottom: '1px solid #e8e8e8',
  },
  tabsIndicator: {
    backgroundColor: '#46C082',
  },
  tabRoot: {
    textTransform: 'initial',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover': {
      color: '#46C082',
      opacity: 1,
    },
    '&$tabSelected': {
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
});

function TabContainer(props) {
    return (
      <Typography component="div" style={{ padding: 8 * 3 }}>
        {props.children}
      </Typography>
    );
  }

const Calendario = ({ classes, fecha, setFecha, value, setValue, calendarioPedidos, refresh, setRefresh, setOpened, opened }) => {

    const handleChange = (value) => {
        setValue(value);
    };

    return (
        <>
            <div>
                <TitleBar 
                    title={'Calendario de pedidos'} 
                    buttons={
                    <div>  
                        <TextField
                            id="date"
                            label="Fecha"
                            type="date"
                            value={fecha}
                            onChange={(e) => setFecha(e.target.value)}
                            className={classes.textField}
                            InputLabelProps={{
                            shrink: true,
                            }}
                        />                             
                        <Button variant="contained" className="btnPrincipal" onClick={() => {setRefresh(!refresh)}}>ACTUALIZAR</Button>     
                    </div>
                    }
                />
            </div>
            <div className={classes.root}>
                <Tabs
                value={value}
                onChange={(e, v) => handleChange(v)}
                classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
                >
                <Tab
                    disableRipple
                    classes={{ root: classes.tabRoot }}
                    label="PICK UP"
                />
                <Tab
                    disableRipple
                    classes={{ root: classes.tabRoot }}
                    label="DELIVERY"
                />
                </Tabs>
            </div>
            {value === 0 && <TabContainer><Turnos {...{calendarioPedidos, value, fecha, setOpened, opened}} /></TabContainer>}
            {value === 1 && <TabContainer><Turnos {...{calendarioPedidos, value, fecha, setOpened, opened}} /></TabContainer>}
        </>
    );
  }

Calendario.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Calendario);